<template>
  <div v-if="show">
    <div>
      {{$t('warningBox.chrome.text')}}
      <b-button size="-small" variant="-primary" href="https://www.google.com/chrome/browser/desktop/" target="_blank">{{$t('warningBox.chrome.download')}}</b-button>
    </div>
    <div class="flex-grow-0">
      <b-button size="-small" variant="-ternary btn--outline" @click="handleHide">{{$t('warningBox.chrome.hide')}}</b-button>
    </div>
  </div>
</template>

<script>
  import LocalStorage from "@/libs/LocalStorage";

  export default {
    name: "WarningBoxChrome",
    data() {
      return {
        show: false
      }
    },
    created(){
      let isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime)
      this.show = !isChrome && !LocalStorage.getValue(LocalStorage.HIDE_CHROME_WARNING);
    },
    methods: {
      handleHide() {
        LocalStorage.setValue(LocalStorage.HIDE_CHROME_WARNING, 1);
        this.show = false;
      }
    }
  }
</script>
